import React from 'react';
import { Alert } from 'reactstrap';

const AlertMessage = ({ visible, message, color = "danger", toggle }) => {
    if (!visible) return null;
    return (
        <Alert color={color} toggle={toggle} fade>
            {message}
        </Alert>
    );
};

export default AlertMessage;